export default "__VITE_ASSET__b3fe6a83__"